import React, { Component } from "react";
import { Collapse, Switch, Button, List, Modal } from "antd";
import { sortableHandle } from "react-sortable-hoc";
import { SvgIcon, Row, Col, ImageLoader } from "../../common";
import ReactDragListView from "react-drag-listview";
import "./collage.scss";

import AddHomepageCollection from "../collections/add-homepage-collection/add-homepage-collection";

import { connect } from "react-redux";
import {
  activateInActivateSection,
  createLoadingSelector,
  getHomePageLists,
  resetStoreState,
  saveHomeCollageSequence,
  deleteHomeCollage,
} from "../../../redux/action";
import { baseServerAdress } from "../../../constants/server-address";
import confirm from "antd/lib/modal/confirm";

const { Panel } = Collapse;
const DragHandle = sortableHandle(() => (
  <SvgIcon className="move-icon-card" name="move-dotes" viewbox="0 0 20 32" />
));

const panelHeader = (
  disableButton,
  activateInActivateSection,
  sectionDetails,
  saveSequence
) => (
  <React.Fragment>
    <React.Fragment>
      <div className="panel-header">
        <div className="title-left d-flex align-items-center">
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <DragHandle />
          </div>
          Collage
        </div>
        <div
          className="title-switch"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Switch
            className="switch-cms"
            defaultChecked
            size="large"
            onChange={(checked) => {
              let requestObject = {
                trans_flag: checked ? "A" : "D",
                id: sectionDetails.id,
              };
              activateInActivateSection(requestObject);
            }}
            checked={sectionDetails.trans_flag === "A"}
          />
        </div>
        <div
          className="save-btn"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Button
            size="small"
            className="btn-success btn-md radius px-3"
            disabled={disableButton}
            onClick={saveSequence}
          >
            Save
          </Button>
        </div>
      </div>
    </React.Fragment>
  </React.Fragment>
);

class HomeCollage extends Component {
  state = {
    data: this.props.contentList,
  };

  handleclassNameChange = (e) => {
    this.setState({ gridclass: e.target.value });
  };

  onDragEnd = (fromIndex, toIndex) => {
    if (toIndex < 0) return; // Ignores if outside designated area

    const items = [...this.state.data];
    const item = items.splice(fromIndex, 1)[0];
    items.splice(toIndex, 0, item);
    this.setState({ data: items });
    this.props.setSectionsSequenceChanged(true);
  };

  onChangeCollapse = (value) => {
    this.props.onChangeCollapse(value);
  };

  handleOk = () => {
    this.props.setSectionsSequenceChanged(false);
    this.saveSequence();
  };

  handleCancel = () => {
    this.props.setShowSectionSequenceAlert(false);
  };

  resetSequence = () => {
    this.setState({
      data: this.props.contentList,
    });
    this.props.setShowSectionSequenceAlert(false);
    this.props.setSectionsSequenceChanged(false);
  };

  saveSequence = () => {
    let items = this.state.data.map((item) => {
      return { id: item.id };
    });
    this.props.saveHomeCollageSequence(items);
  };

  static getDerivedStateFromProps(props, state) {
    if (props.contentList !== state.unUsedData) {
      return { data: props.contentList, unUsedData: props.contentList };
    }
    return null;
  }

  getGridClassName = () => {
    if (this.state.data.length < 3) {
      return "grid2";
    }

    return `grid${this.state.data.length}`;
  };
  handleDeleteHomeCollage = (id) => {
    confirm({
      title: "Do you really want to Delete?",
      // content: "Are you sure you want to sign out from your account?",
      onOk: () => {
        this.props.deleteHomeCollage(id);
      },
    });
  };
  render() {
    const { loading } = this.state;
    return (
      <React.Fragment>
        <Modal
          className="modal-cms alert-modal"
          visible={
            this.props.showSectionSequenceAlert &&
            this.props.activeKeys.toString() === ["2"].toString()
          }
          title="Alert"
          onCancel={this.handleCancel}
          closeIcon={<SvgIcon name="close" viewbox="0 0 298.667 298.667" />}
          footer={[
            <Button key="back" size="small" onClick={this.resetSequence}>
              No
            </Button>,
            <Button
              key="submit1"
              size="small"
              type="primary"
              loading={loading}
              onClick={this.handleOk}
            >
              Yes
            </Button>,
            <Button
              key="submit2"
              size="small"
              type="primary"
              onClick={this.handleCancel}
            >
              keep editing
            </Button>,
          ]}
        >
          <p className="alret-modal-text">
            <SvgIcon
              className="mb-n1 mr-1"
              name="info-icon"
              viewbox="0 0 35.446 35.446"
            />{" "}
            Would you like to save your changes ?
          </p>
        </Modal>
        <Collapse
          accordion
          expandIconPosition="right"
          activeKey={this.props.activeKeys}
          onChange={this.onChangeCollapse}
        >
          <Panel
            header={panelHeader(
              !this.props.isSectionsSequenceChanged,
              this.props.activateInActivateSection,
              this.props.sectionDetails,
              this.saveSequence
            )}
            key="2"
          >
            {/* <Radio.Group className="gridradio" value={this.state.gridclass} onChange={this.handleclassNameChange}>
                            <Radio.Button value="grid2"><SvgIcon name="grid2" viewbox="0 0 180 81" /></Radio.Button>
                            <Radio.Button value="grid3"><SvgIcon name="grid3" viewbox="0 0 182 47" /></Radio.Button>
                            <Radio.Button value="grid4"><SvgIcon name="grid4" viewbox="0 0 181 36" /></Radio.Button>
                            <Radio.Button value="grid5"><SvgIcon name="grid5" viewbox="0 0 181 81" /></Radio.Button>
                            <Radio.Button value="grid6"><SvgIcon name="grid6" viewbox="0 0 144 90" /></Radio.Button>
                        </Radio.Group> */}
            <Row className="mt-3">
              <Col sm="12">
                <ReactDragListView
                  nodeSelector=".ant-list-item.draggble"
                  onDragEnd={this.onDragEnd}
                >
                  <List
                    size="small"
                    bordered
                    dataSource={this.state.data}
                    className="card-listslider-banner"
                    renderItem={(item) => {
                      const draggble = item !== " ";
                      return (
                        <List.Item className={draggble ? "draggble" : ""}>
                          <div className="collection-card collage-grid">
                            <div className="remove-card">
                              <div
                                className="close-icon"
                                onClick={() =>
                                  this.handleDeleteHomeCollage(item.id)
                                }
                              >
                                <SvgIcon
                                  name="close"
                                  viewbox="0 0 298.667 298.667"
                                />
                              </div>
                            </div>
                            <div className="collection-cardinner">
                              <div className="image-thumb">
                                <div className="imagethumb-inner">
                                  <ImageLoader
                                    alt={"collectionimage"}
                                    src={
                                      baseServerAdress.COLLECTION_IMAGE +
                                      item.thumb_image +
                                      `?${Date()}`
                                    }
                                  />
                                </div>
                              </div>
                              <div className="right">
                                <h3>{item.name}</h3>
                                <p>
                                  {(item.collection_items === null
                                    ? 0
                                    : item.collection_items) +
                                    ` Item${
                                      item.collection_items === 1 ? "" : "s"
                                    }, ` +
                                    (item.collection_childs === null
                                      ? 0
                                      : item.collection_childs) +
                                    ` Collection${
                                      item.collection_childs === 1 ? "" : "s"
                                    }`}
                                </p>
                              </div>
                            </div>
                          </div>
                        </List.Item>
                      );
                    }}
                  />
                </ReactDragListView>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <AddHomepageCollection
                  selectedHomeCollections={this.props.contentList}
                  isForCollage={true}
                />
              </Col>
            </Row>

            <Row className="mt-4">
              <Col>
                <div className="collage-preview">
                  <div className="collage-preview-label">Collage preview</div>
                  <ul className={this.getGridClassName()}>
                    {this.state.data.map((item) => (
                      <li key={item.id}>
                        <ImageLoader
                          alt={"collectionimage"}
                          src={
                            baseServerAdress.COLLECTION_IMAGE +
                            item.thumb_image +
                            `?${Date()}`
                          }
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
            </Row>
          </Panel>
        </Collapse>
      </React.Fragment>
    );
  }
}

const loadingSelector = createLoadingSelector([
  //serverApis.deleteHomeSlider.actionName,
]);

const mapStateToProps = (state) => ({
  isFetchingData: loadingSelector(state),
});

export default connect(mapStateToProps, {
  resetStoreState,
  getHomePageLists,
  activateInActivateSection,
  saveHomeCollageSequence,
  deleteHomeCollage,
})(HomeCollage);
